import Alpine from 'alpinejs';
import AsyncForm from './components/async-form';
import Carousel from './components/carousel';
import Modal from './components/modal';

window.Alpine = Alpine;

Alpine.data('asyncForm', AsyncForm);
Alpine.data('carousel', Carousel);
Alpine.data('modal', Modal);

Alpine.start();
